import rem from '@/utils/rem';

export const projectSelectorRow = {
  projectSelectorRowTitle: {
    fontSize: rem(13),
    fontWeight: 500,
    lineHeight: '130%',
    letterSpacing: '0',
  },
};
